import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_LAYERGROUPS, FETCH_LAYERGROUP } from './actions.type'
import { SET_LAYERGROUPS, SET_LAYERGROUPS_ERRORS, SET_LAYERGROUPS_LOADING, SET_LAYERGROUP, SET_LAYERGROUP_ERRORS, SET_LAYERGROUP_LOADING } from './mutations.type'

const state = {
	layerGroups: [],
	layerGroupsErrors: [],
	layerGroupsIsLoading: false,
	layerGroup: null,
	layerGroupErrors: [],
	layerGroupIsLoading: false
}

const getters = {
	layerGroups : state => key => {
		return state.layerGroups.filter(x => x.name.toLowerCase().includes(key.toLowerCase()))
	},
	layerGroupsErrors (state) {
		return state.layerGroupsErrors
	},
	layerGroupsIsLoading (state) {
		return state.layerGroupsIsLoading
	},
	layerGroup (state) {
		return state.layerGroup
	},
	layerGroupErrors (state) {
		return state.layerGroupErrors
	},
	layerGroupIsLoading (state) {
		return state.layerGroupIsLoading
	},
}

const actions = {
	[FETCH_LAYERGROUPS] (context, params) {
		context.commit(SET_LAYERGROUPS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/layergroups')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_LAYERGROUPS, data)
					resolve(data)
				} else {
					context.commit(SET_LAYERGROUPS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_LAYERGROUPS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_LAYERGROUPS_LOADING, false)
			})
		})
	},
	[FETCH_LAYERGROUP] (context, params) {
		context.commit(SET_LAYERGROUP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/layergroups', params.name)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_LAYERGROUP, data)
					resolve(data)
				} else {
					context.commit(SET_LAYERGROUP_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_LAYERGROUP_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_LAYERGROUP_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_LAYERGROUPS] (state, data) {
		state.layerGroups = data
		state.layerGroupsErrors = []
	},
	[SET_LAYERGROUPS_ERRORS] (state, errors) {
		state.layerGroups = []
		state.layerGroupsErrors = errors
	},
	[SET_LAYERGROUPS_LOADING] (state, status = true) {
		state.layerGroupsIsLoading = status
	},
	[SET_LAYERGROUP] (state, data) {
		state.layerGroup = data
		state.layerGroupErrors = []
	},
	[SET_LAYERGROUP_ERRORS] (state, errors) {
		state.layerGroup = []
		state.layerGroupErrors = errors
	},
	[SET_LAYERGROUP_LOADING] (state, status = true) {
		state.layerGroupIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/layergroups.module.js